import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 0
})

service.interceptors.response.use(
  response => response,
  error => {
    if (typeof error.response === 'undefined') {
      alert('A network error occurred. '
          + 'This could be a CORS issue or a dropped internet connection. '
          + 'It is not possible for us to know.')
    }

    return Promise.reject(error)
  })

export default service
